/* Toggle Beverage Mobile menu */
$(document).ready(function() {

$(document).on('click', '.show_beverages' ,function () {
    $(".coll_tag").toggle();
});
  
/* Toggle Merch Mobile menu */
 $(document).on('click', '.merches' ,function () {
    $(".cu-collist").toggle();
   });
  
  
/*Menu Toggle */
  $(".site-nav__link--button").on("click",function(){ 
    $(".site-nav--has-dropdown").toggleClass("show_dropdown_menu"); 
    
                                                    
});

//   $('body').on('click',function(){
//          $(".site-nav--has-dropdown").removeClass("show_dropdown_menu"); 

// })

   /* Coming Soon Product */
  $(".product_comming").on("click",function(e){
    e.preventDefault(); 
  });

  
 /*Related Product slider */
  $('.related_sliders').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 7,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
        breakpoint: 1281,
        settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        dots: false,
      } 
     },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        dots: false,
      }
    },
    {
            breakpoint: 750,
            settings: "unslick", 
     },
    {
      breakpoint: 480,
      settings:  "unslick",
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
  /* help center */
$('.reviews_ratings').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          dots: true
        }
      },

      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
});

  /* selected other dropdown */
  $('#ContactFormFlavor').on('change', function() {
 if($(this).val() == "other") {
        $(".other_descritpion").show();
    }
    if($(this).val() != "other") {
        $(".other_descritpion").hide();
    }
  
});

  
 /*contact page Tab */
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontents");
    console.log(this.tabcontent);
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablink");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
  setTimeout(function(){ 
  
  //$(".index-section").attr("id","history");
    
  }, 200);
  
  /* location page mobile drodown */
  $(".location_prov").on("click",function(){
    $(".location_data").toggle();
    
    
  });
       
$(".location_data li").on("click",function(){
    var title =$(this).attr('data-name');
    console.log(title);
    if(title == 'all'){
      var all_regions= $(".loc-data-result").html();
      console.log(all_regions);
      $(".provinces").text(title);
      $(".location_data").hide();
      $(".location_results_items").addClass("new_regions");
//       $(".location_results_items").html(all_regions);
      $(".loc-data-result").show();
      $(".location_results").hide();
      
      console.log("hlo");
    }
    else{
    $(".provinces").text(title);
    $(".location_data").hide();
   var result_data = $(this).find(".map-loc-info").html();
    console.log(result_data);
    $(".replace_result").addClass("new_regions");
    $(".replace_result").html(result_data);
    $(".location_results").show();
    $(".loc-data-result").hide();
      console.log("bye");
  
    }
  });

  $(".map-pointer").hover(function () {
                //toggleClass() switches the active class
              var g= $(this).find(".map-loc-info");
               g.toggleClass("active");
               
                
            });
  $(".announce_btn").on("click", function(){
    $(".announcement-bar").remove();
  });
  
  /* contact page ul li */
   $(".phone_code>li").on("click",function(e){
   var phn_text =$(this).val();
    $(".country_value").text(phn_text);
     $(".phone_code").hide();
    
  });
  
  /*collection page Filter js */
    /* collection tag filter */
 $(document).on('click', '.collection_tag_lists>li' ,function (e) {
 e.preventDefault();
     var tags_name =$(this).text();
    console.log(tags_name);
    $(".mobiles_prov ").text(tags_name);
    
    $(".tags_mobile").hide();
    /* Add/remove Class */
  $(this).parent('ul').find ('li a.activelist').removeClass('activelist');
       var liClasses= $(this).find("a");
       liClasses.addClass("activelist");
   var tag_handles = $("ul.cu-collist li .activelist").attr("data-url"); 
   var parts = tag_handles.split("/");
    var last_parts = parts[parts.length-1];
    // console.log("hlo" +tag_handles);
    var tag_handle= last_parts;
            //console.log($(this).text());
            var tag= $(this).attr('data-url');
           tagAjax(tag_handle,tag);
   
  });
  
 function tagAjax(tag_handle,tag) {
   var tag_url= tag_handle;
   var url      = window.location.href;
    const state = { 'user': 'guest' }
    const title = ''
       console.log("ddd"); 
    history.pushState(state, title, "/collections/"+tag_handle+"/"+tag);
  
   //console.log(tag_handle);
  $.ajax({
     url: '/collections/'+tag_handle+'/'+tag,
     type:'GET',
     success: function(data){
     var tag_result = $(data).find('.collection_data').html();
      var result = $(".collection_data").html(tag_result);
       
     }
  });
}
  /* collection related filter */
 $(document).on('click', '.cu-collist>li' ,function (e) {
e.preventDefault();
    $(".coll_tag").hide();
    /* Add remove Class */
   $(this).parent('ul').find ('li a.activelist').removeClass('activelist');
      var liClass= $(this).find("a");
       liClass.addClass("activelist");
    
    var collection_name =$(this).text();
    $(".mobile_bev").text(collection_name);
    $(".mobile_culist").hide();
    var collection_handle= $(this).attr('collection-url');
    var tag_name= $(".collection_tag_lists li .activelist").attr("data-id"); 
   
   collectionAjax(collection_handle,tag_name);
  });
  /* Call collection filter Ajax */
   function collectionAjax(collection_handle,tag_name) {
   var collection_url= collection_handle;
     var parts = collection_url.split("/");
    var last_part = parts[parts.length-1];
  
     const state = { 'user': 'guest' }
        const title = ''
         //console.log(url); 
     
     if(tag_name){
       console.log("yes tag");
        history.pushState(state, title, "/collections/"+last_part+"/"+tag_name);
    $.ajax({
     url: collection_handle+"/"+tag_name,
     type:'GET',
     success: function(result){
       
     var tag_result = $(result).find('.collection_data').html();
      var result = $(".collection_data").html(tag_result);
     }
  });
 }
 else
  {
    console.log("no tag");
  history.pushState(state, title, "/collections/"+last_part);

  $.ajax({
     url: collection_handle,
     type:'GET',
     success: function(result){
       
     var tag_result = $(result).find('.collection_data').html();
      var result = $(".collection_data").html(tag_result);
     }
  });  
       
  }
}
 
  $(".icon-hamburger").on("click",function(){
    $("header").addClass("open_headers"); 
  });
  
   $(".icon-close").on("click",function(){
    $("header").removeClass("open_headers"); 
  });
  
  /* Our Partner Page Slick slider */
  $('.partner_slider').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    draggable: true,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  }); 
  
  
   /*Change Product Feature image on click thubnail image */
 
  $('.product-single__thumbnail-image').on('click', function(e) { 
    e.preventDefault();
    var thubnail_img =$(this).attr("data-attr");
    $(".product-single__media img").attr('srcset', thubnail_img);
  });
  
  /*sorting the list */
   $('.location_data li').sort(function(a, b) {
       if (a.textContent < b.textContent) {
         return -1;
       } else {
         return 1;
       }
     }).appendTo('.location_data');
  
});
